document.addEventListener('DOMContentLoaded', () => {
  const ele = document.getElementById('sort')
  if (ele) {
    // If params for sorting is exist, change selected value
    const sort_param = new URLSearchParams(window.location.search).get("sort");
    Array.from(ele.options).forEach((option) => {
      if (option.value === sort_param) {
        ele.value = sort_param
      }
    })
    // Add sorting
    ele.addEventListener("change", () => {
      window.location.href = `${window.location.href.split('?')[0]}?sort=${ele.value}`;
    })
  }
});
